export default __webpack_public_path__ + "e0dc952f05693cb599ce10c3a92d09b8.svg";